import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDate } from '../../utils/helpers';

const DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dayOf = (d) => { const t = new Date(`${String(d || '').slice(0, 10)}T00:00:00`); return Number.isNaN(t.getTime()) ? '' : DAY[t.getDay()]; };

// Desktop "Group (count only)" - one compact line of fields, then the
// functions as a two-column list. Every box only as wide as what goes in it.
// Enter saves; "Save & next" keeps whose / functions / card for the next group.
// Logic in useCountGroup.
export default function CountGroupFormDesktop({ vm }) {
  const {
    groupForm, setG, toggleGroupFunction, setAllGroupFunctions, groupFunctions, memberOptions,
    saveGroup, groupSaving, setGroupOpen,
  } = vm.countGroup;
  const editing = !!groupForm.GuestId;
  const ticked = groupForm.FunctionIds.length;
  const persons = Number(groupForm.Persons || 0);
  const onEnter = (e) => { if (e.key === 'Enter') { e.preventDefault(); saveGroup(); } };

  return (
    <Modal className="cg-modal" title={editing ? `Group - ${groupForm.GuestName || 'count only'}` : 'Add group (count only)'}
      onClose={() => setGroupOpen(false)}
      footer={<>
        <span className="cg-summary">
          {persons > 0 && ticked > 0
            ? <><strong>{persons}</strong> {persons === 1 ? 'person' : 'persons'} at <strong>{ticked}</strong> {ticked === 1 ? 'function' : 'functions'}</>
            : 'Name, persons, whose guests and at least one function'}
        </span>
        <button className="btn light" onClick={() => setGroupOpen(false)}>Cancel</button>
        {!editing && (
          <button className="btn light" onClick={() => saveGroup({ next: true })} disabled={groupSaving}
            title="Save and start the next group for the same person (Ctrl+Shift+S)">Save &amp; next</button>
        )}
        <button className="btn primary" onClick={() => saveGroup()} disabled={groupSaving}>{groupSaving ? 'Saving…' : 'Save'}</button>
      </>}>
      <div className="cg-row">
        <label className="field cg-name">Group name *
          <input autoFocus value={groupForm.GuestName} placeholder="e.g. School Friends" maxLength={60}
            onChange={(e) => setG('GuestName', e.target.value)} onKeyDown={onEnter} />
        </label>
        <label className="field cg-persons">Persons *
          <input inputMode="numeric" value={groupForm.Persons} placeholder="6"
            onChange={(e) => setG('Persons', e.target.value.replace(/\D/g, '').slice(0, 3))} onKeyDown={onEnter} />
        </label>
        <label className="field cg-member">Guest of *
          <select value={groupForm.MemberId} onChange={(e) => setG('MemberId', e.target.value)}>
            <option value="">- select member -</option>
            {memberOptions.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
        </label>
        <label className="field cg-card">Card
          <select value={groupForm.Card ? '1' : '0'} onChange={(e) => setG('Card', e.target.value === '1')}>
            <option value="0">No card</option>
            <option value="1">One card</option>
          </select>
        </label>
      </div>

      <div className="cg-fn-head">
        <span className="step-label">Invited to</span>
        <span className="cg-fn-tools">
          <button type="button" className="link-btn" onClick={() => setAllGroupFunctions(true)}>All</button>
          <button type="button" className="link-btn" onClick={() => setAllGroupFunctions(false)}>None</button>
        </span>
      </div>
      <div className="cg-fn-grid">
        {groupFunctions.map(f => {
          const on = groupForm.FunctionIds.includes(String(f.FunctionId));
          return (
            <label key={f.FunctionId} className={'cg-fn' + (on ? ' on' : '')}>
              <input type="checkbox" checked={on} onChange={() => toggleGroupFunction(f.FunctionId)} />
              <span className="cg-fn-name" title={f.FunctionName}>{f.FunctionName}</span>
              <span className="cg-fn-date">{dayOf(f.FunctionDate)} {fmtDate(f.FunctionDate).slice(0, 5)}</span>
            </label>
          );
        })}
      </div>
    </Modal>
  );
}
